import React from 'react';
import { useTheme } from '../context/ThemeContext';

const HeartIcon = ({ filled = false, forceColor = null }) => {
  const { darkMode } = useTheme();
  
  // If forceColor is specified, use that. Otherwise, use theme-based colors
  const getStrokeColor = () => {
    if (filled) return "red";
    if (forceColor) return forceColor;
    return darkMode ? "#fff" : "black";
  };
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill={filled ? "red" : "none"}
      stroke={getStrokeColor()}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
    </svg>
  );
};

export default HeartIcon;
